import {NgModule} from '@angular/core';
import {SharedModule} from '../shared/shared.module';
import {PriceService} from './price.service';
import {PriceOverviewComponent} from './price-overview.component';
import {PriceFormComponent} from './price-form.component';

@NgModule({
  declarations: [
    PriceOverviewComponent,
    PriceFormComponent
  ],
  exports: [
    PriceOverviewComponent,
    PriceFormComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    PriceService
  ]
})
export class PriceModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/price/price.module.ts